<template>
      <v-container fluid class="terms-c">
        <v-row>
          <v-col cols="12">
            <v-card class="mx-auto my-5 card-terms" max-width="70%">
              <v-card-title>
                <br>
                <v-toolbar-title><b>Terms and Conditions of Use for XSINT</b></v-toolbar-title>
                <br>
              </v-card-title>
              <a href="/gtc" style="margin-left:18px" ><b><u>GTC</u></b></a>
              <br><br>
              <v-card-subtitle>
                Effective Date: August 1, 2024
              </v-card-subtitle>
              <v-card-text>
                <p>Welcome to XSINT ("we," "us," "our"). By accessing or using XSINT (the "Service"), you agree to be bound by these Terms and Conditions (the "Terms"). Please read them carefully.</p>
                <br>
                <v-divider></v-divider>
                <br>
                <div class="terms-section">
                  <h2>1. Acceptance of Terms</h2>
                  <p>By accessing or using XSINT, you agree to comply with and be bound by these Terms and any additional terms or policies that may apply. If you do not agree to these Terms, you must not use the Service.</p>
                </div>
  
                <div class="terms-section">
                  <h2>2. Service Description</h2>
                  <p>XSINT provides tools for researching information related to email addresses, phone numbers, and accessing databases containing leaked data. The Service is intended for lawful and ethical use only.</p>
                </div>
  
                <div class="terms-section">
                  <h2>3. Authorized Use</h2>
                  <p>You are permitted to use XSINT solely to search for information related to your own email addresses or phone numbers. You must not use the Service to search for information related to any third parties without their explicit consent.</p>
                </div>
  
                <div class="terms-section">
                  <h2>4. User Responsibilities</h2>
                  <p><strong>Account Security:</strong> You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
                  <p><strong>Legal Compliance:</strong> You agree to use the Service in accordance with all applicable laws and regulations.</p>
                  <p><strong>Prohibited Activities:</strong> You may not use XSINT to engage in activities that are illegal, unethical, or in violation of these Terms.</p>
                </div>
  
                <div class="terms-section">
                  <h2>5. Privacy Policy</h2>
                  <p>Your use of XSINT is also governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information. By using the Service, you consent to the practices described in the Privacy Policy.</p>
                </div>

                <div class="terms-section">
                  <h2>6. Rights of Data Subjects</h2>
                  <p>
                  <u>In accordance with the General Data Protection Regulation (GDPR), you have the following rights regarding your personal data:</u><br>
                  -Right of Access (Article 15): You have the right to request access to your personal data that we process.<br>
                  -Right to Rectification (Article 16): You have the right to request the correction of any inaccurate or incomplete personal data.<br>
                  -Right to Erasure (Article 17): You may request the deletion of your personal data when it is no longer necessary for the purposes for which it was collected.<br>
                  -Right to Restriction of Processing (Article 18): You have the right to request the limitation of processing your personal data under certain circumstances.
                  -Right to Data Portability (Article 20): You have the right to receive your personal data in a structured, commonly used, and machine-readable format and to request the transfer of such data to another controller.<br>
                  -Right to Object (Article 21): You have the right to object to the processing of your personal data at any time.<br>
                  -Right Not to Be Subject to Automated Decision-Making (Article 22): You have the right not to be subject to a decision based solely on automated processing.<br>
                </p>
                </div>
  
                <div class="terms-section">
                  <h2>7. Service Disruptions</h2>
                  <p>XSINT aims to provide a reliable and uninterrupted service. However, we cannot guarantee that the Service will always be available or free from disruptions. The Service may be affected by technical issues, maintenance, or other factors beyond our control.</p>
                </div>
  
                <div class="terms-section">
                  <h2>8. Subscription and Refund Policy</h2>
                  <p><strong>No Refunds for Cancellations:</strong> Subscriptions that are canceled or terminated before the end of the subscription period are not eligible for a refund. All fees paid are non-refundable.</p>
                  <p><strong>Loss of Benefits:</strong> Upon cancellation or termination of a subscription, you will lose access to all benefits and features associated with that subscription.</p>
                </div>
  
                <div class="terms-section">
                  <h2>9. Limitations of Liability</h2>
                  <p>XSINT is provided "as is" and "as available" without any warranties of any kind. We do not guarantee the accuracy, completeness, or timeliness of the information available through the Service.</p>
                </div>
  
                <div class="terms-section">
                  <h2>10. Indemnification</h2>
                  <p>You agree to indemnify, defend, and hold harmless XSINT, its affiliates, officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, or expenses, including reasonable attorneys' fees, arising out of or related to your use of the Service or any violation of these Terms.</p>
                </div>
  
                <div class="terms-section">
                  <h2>11. Modifications to Terms</h2>
                  <p>We may update these Terms from time to time. Any changes will be posted on this page, and it is your responsibility to review these Terms periodically.</p>
                </div>
  
                <div class="terms-section">
                  <h2>12. Termination</h2>
                  <p>We reserve the right to terminate or suspend your access to XSINT at our sole discretion, with or without cause, and with or without notice, for any reason, including but not limited to violation of these Terms.</p>
                </div>
  
                <div class="terms-section">
                  <h2>13. Governing Law</h2>
                  <p>These Terms shall be governed by and construed in accordance with the laws of France. Any disputes arising under or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts located in France.</p>
                </div>
  
                <div class="terms-section">
                  <h2>14. Contact Information</h2>
                  <p>If you have any questions about these Terms or the Service, please contact us at:</p>
                  <p><strong>XSINT Support Team</strong><br>
                  Email: <a href="mailto:contact@xsint-intelligence.com">contact@xsint-intelligence.com</a></p>
                </div>
  
                <div class="terms-section">
                  <h2>15. Disclaimer Regarding Leaked Data</h2>
                  <p>XSINT may provide access to databases containing leaked data. XSINT does not guarantee the legality or accuracy of the information in these databases. The use of information from these databases is at your own risk. XSINT neither supports nor participates in the creation or distribution of leaked data.</p>
                </div>
  
                <div class="terms-section">
                  <h2>16. Service Availability</h2>
                  <p>XSINT strives to maintain the availability of the Service. However, the Service may experience interruptions or technical issues due to maintenance or unforeseen circumstances. XSINT will not be liable for any inconvenience or loss resulting from such service disruptions.</p>
                </div>
  
                <div class="terms-section">
                  <h2>17. Intellectual Property</h2>
                  <p>XSINT retains all rights, titles, and interests in the Service and its content, including all intellectual property rights. You may not use, reproduce, or distribute any content from the Service without our prior written consent.</p>
                </div>
  
                <div class="terms-section">
                  <h2>18. Force Majeure</h2>
                  <p>XSINT shall not be held liable for any failure to perform its obligations under these Terms if such failure is due to circumstances beyond its reasonable control, including but not limited to natural disasters, government actions, or technical failures.</p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
  </template>
  
  <style scoped>

.terms-c{
  margin-top: 100px
}

.card-terms{
  background-color: #111111
}

  .terms-section {
    margin-bottom: 16px; 
  }
  
  .terms-section h2 {
    font-size: 1.25rem; 
    font-weight: 600; 
    margin-bottom: 8px; 
  }
  
  .terms-section p {
    margin: 0; 
    font-size: 18px;
  }
  
  .v-card-text {
    white-space: normal; 
    word-wrap: break-word;
  }
  </style>

<script setup>
import { useHead } from '@vueuse/head';

useHead({
  title: 'Terms | XSINT Intelligence',
  meta: [  
    { name: 'keywords', content: 'terms, terms & conditions, XSINT, XSINT Intelligence, xsint' },
    
    { property: 'og:title', content: 'Terms | XSINT Intelligence' },
    { name: 'twitter:title', content: 'Terms | XSINT Intelligence' },

    { name: 'description', content: 'XSINT terms of use page' },
    { property: 'og:description', content: 'XSINT terms of use page' },
    { name: 'twitter:description', content: 'XSINT terms of use page' },

    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://www.xsint-intelligence.com/terms' },
    { name: 'robots', content: 'index, follow' },
    { name: 'author', content: 'XSINT Intelligence' }
  ]
});
</script>
  